import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map, catchError, finalize } from 'rxjs/operators';
import { ChecklistRepository } from '../../../infrastructure/repositories/checklist.repository';
import { ChecklistListState } from '../../states/checklist-list.state';
import { ToggleChecklistDisplayResult } from './toggle-checklist-display.result';

@Injectable({ providedIn: 'root' })
export class ToggleChecklistDisplayUseCase {
  private readonly _repository = inject(ChecklistRepository);
  private readonly _state = inject(ChecklistListState);

  public execute(caseTypeId: string, displayOnCases: boolean): Observable<ToggleChecklistDisplayResult> {
    this._state.setSaving(true);
    this._state.clearError();

    return this._repository.toggleChecklistDisplay(caseTypeId, displayOnCases).pipe(
      switchMap(() =>
        this._repository.getAllChecklists().pipe(
          map((result) => {
            this._state.setChecklists(result.data);
            this._state.setChecklistsCount(result.totalElements);
            return { success: true };
          }),
        ),
      ),
      catchError((error) => {
        this._state.setError(error?.error?.message || error?.message || 'Failed to toggle checklist display');
        throw error;
      }),
      finalize(() => this._state.setSaving(false)),
    );
  }
}
